import {
  Announcement,
  Footer,
  Guests,
  Hero,
  Location,
  SEO,
  Wishes,
} from "./components";
import { useEffect } from "react";
import { op } from "./utils";

export const App = () => {
  const mode = import.meta.env.MODE;

  useEffect(() => {
    op.setGlobalProperties({
      app_version: "1.0.0",
      environment: mode,
    });
  }, []);

  return (
    <div className="min-h-full flex flex-col safe-area-bottom">
      <main className="flex-1 w-full flex flex-col px-4 py-8">
        <SEO />

        <Hero />

        <Announcement />

        <Location />

        <Wishes />

        <Guests />
      </main>

      <Footer />
    </div>
  );
};
